import React from "react";
import "../App.scss";
import Navbar from "./Navbar";
import CheckoutCounter from "./Counter";

export default function MainWrapper({ children }) {
  return (
    <div className="initial-layout">
      <Navbar />
      <div className="wrapper-content">{children}</div>
      <CheckoutCounter />
    </div>
  );
}
